import { formatCurrency } from "@brazilian-utils/brazilian-utils";
import colors from "core/resources/theme/colors";
import { AiFillWarning, AiOutlinePercentage } from "react-icons/ai";
import { MdOutlineAttachMoney } from "react-icons/md";
import { SimpleGrid } from "@chakra-ui/layout";
import Card2Horizontal from "components/Cards/Card2Horizontal";

function DashboardInadimplentes({
  totalDivida = 0,
  totalDividaPrincipal = 0,
  totalInadimplentes = 0,
  porcentagemInadimplente = 0,
  isLoading,
}: {
  totalDivida?: number;
  totalDividaPrincipal?: number;
  totalInadimplentes?: number;
  porcentagemInadimplente?: number;
  isLoading?: boolean;
}) {
  return (
    <>
      <SimpleGrid columns={{ sm: 1, md: 2, lg: 4 }} gap="16px" mb="32px">
        <Card2Horizontal
          icon={<MdOutlineAttachMoney fontSize="24px" color={colors.blue} />}
          color={colors.blue}
          bg={colors.blue100}
          description="Total da dívida atualizado"
          title={`R$ ${formatCurrency(totalDivida || 0)}`}
          loading={isLoading}
        />

        <Card2Horizontal
          icon={<MdOutlineAttachMoney fontSize="24px" color={colors.gray} />}
          color={colors.gray}
          bg={colors.gray50}
          description="Total da dívida principal"
          title={`R$ ${formatCurrency(totalDividaPrincipal || 0)}`}
          loading={isLoading}
        />

        <Card2Horizontal
          icon={<AiFillWarning fontSize="24px" color={colors.red} />}
          color={colors.red}
          bg={colors.red100}
          description="Total de inadimplentes"
          title={`${totalInadimplentes}`}
          loading={isLoading}
        />

        <Card2Horizontal
          loading={isLoading}
          icon={<AiOutlinePercentage fontSize="24px" color={colors.orange} />}
          color={colors.orange}
          bg={colors.yellow100}
          description="% inadimplente"
          title={`${(porcentagemInadimplente || 0).toFixed(1)}%`}
        />
      </SimpleGrid>
    </>
  );
}

export default DashboardInadimplentes;
